import { useThreadViewport } from "@assistant-ui/react";

export const useIsAtBottom = () => useThreadViewport(s => s.isAtBottom);

export const useScrollToBottom = () => useThreadViewport(s => s.scrollToBottom);
